var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{TA:_vm.isTestAchat}},[_c('v-select',{staticClass:"select",attrs:{"options":_vm.options,"components":{Deselect: _vm.Deselect},"searchable":false,"reduce":function (options) { return options.value; },"label":"label","value":_vm.value},on:{"input":_vm.setSelected,"blur":function($event){return _vm.$emit('blur')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8d53bc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/BecomeFields/SelectField.vue
// module id = null
// module chunks = 